import './index.css'

const SvgImg = ({ src, alt, style }: { src: string; alt: any; style?: Record<string, any> }) => {
  return (
    <div className="svg-img" style={style ?? {}}>
      <img src={src} alt={alt} />
    </div>
  )
}

export default SvgImg
